import { LoginHistoryRequestModel, LoginHistoryResponseModel } from "@/features/user/services/login-history-model";
import { ApiClient } from "@/shared/services/api-client";
import { MoneyLinkException } from "@/shared/utils/custom-exception";

export class LoginHistoryApi {
  /**
   * ログイン履歴の取得
   */
  public getLoginHistory = async (
    param: LoginHistoryRequestModel
  ): Promise<LoginHistoryResponseModel[]> => {
    const path = `api/login/history`;
    const res = await ApiClient.instance.get<LoginHistoryResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}